import $ from 'jquery';
import smoothScroll from '../../vendor/smooth-scroll';

if ($('.js-maintain-scroll-position').length) {
  $('.js-maintain-scroll-position').each(function (e) {
    var form = $(this).parents('form');
    var error = $('.form-group .error:not(:empty)', form).first();
    var formGroup = error.parents('.form-group');
    if (error.length) {
      //$('html, body').scrollTop(formGroup.offset().top);
      smoothScroll.smoothScrollTo(formGroup);
    }
  });
}
